{
  "about.blocks": "Moderated servers",
  "about.contact": "Contact:",
  "about.default_locale": "Default",
  "about.disclaimer": "Mastodon is free, open-source software, and a trademark of Mastodon GmbH.",
  "about.domain_blocks.no_reason_available": "Reason not available",
  "about.domain_blocks.preamble": "Mastodon generally allows you to view content from and interact with users from any other server in the fediverse. These are the exceptions that have been made on this particular server.",
  "about.domain_blocks.silenced.explanation": "You will generally not see profiles and content from this server, unless you explicitly look it up or opt into it by following.",
  "about.domain_blocks.silenced.title": "Limited",
  "about.domain_blocks.suspended.explanation": "No data from this server will be processed, stored or exchanged, making any interaction or communication with users from this server impossible.",
  "about.domain_blocks.suspended.title": "Suspended",
  "about.language_label": "Language",
  "about.not_available": "This information has not been made available on this server.",
  "about.powered_by": "Decentralized social media powered by {mastodon}",
  "about.rules": "Server rules",
  "account.account_note_header": "Personal note",
  "account.activity": "Activity",
  "account.add_note": "Add a personal note",
  "account.add_or_remove_from_list": "Add or Remove from lists",
  "account.badges.admin": "Admin",
  "account.badges.blocked": "Blocked",
  "account.badges.bot": "Automated",
  "account.badges.domain_blocked": "Blocked domain",
  "account.badges.group": "Group",
  "account.badges.muted": "Muted",
  "account.badges.muted_until": "Muted until {until}",
  "account.block": "Block @{name}",
  "account.block_domain": "Block domain {domain}",
  "account.block_short": "Block",
  "account.blocked": "Blocked",
  "account.cancel_follow_request": "Cancel follow",
  "account.copy": "Copy link to profile",
  "account.disable_notifications": "Stop notifying me when @{name} posts",
  "account.edit_note": "Edit personal note",
  "account.edit_profile": "Edit profile",
  "account.edit_profile_short": "Edit",
  "account.enable_notifications": "Notify me when @{name} posts",
  "account.endorse": "Feature on profile",
  "account.familiar_followers_many": "Followed by {name1}, {name2}, and {othersCount, plural, one {one other you know} other {# others you know}}",
  "account.familiar_followers_one": "Followed by {name1}",
  "account.familiar_followers_two": "Followed by {name1} and {name2}",
  "account.featured": "Featured",
  "account.featured.accounts": "Profiles",
  "account.featured.collections": "Collections",
  "account.featured.new_collection": "New collection",
  "account.field_overflow": "Show full content",
  "account.filters.all": "All activity",
  "account.filters.boosts_toggle": "Show boosts",
  "account.filters.posts_boosts": "Posts and boosts",
  "account.filters.posts_only": "Posts",
  "account.filters.posts_replies": "Posts and replies",
  "account.filters.replies_toggle": "Show replies",
  "account.follow": "Follow",
  "account.follow_back": "Follow back",
  "account.follow_back_short": "Follow back",
  "account.follow_request": "Request to follow",
  "account.follow_request_cancel": "Cancel request",
  "account.follow_request_cancel_short": "Cancel",
  "account.follow_request_short": "Request",
  "account.followers": "Followers",
  "account.followers.empty": "No one follows this user yet.",
  "account.followers_counter": "{count, plural, one {{counter} follower} other {{counter} followers}}",
  "account.followers_you_know_counter": "{counter} you know",
  "account.following": "Following",
  "account.following_counter": "{count, plural, one {{counter} following} other {{counter} following}}",
  "account.follows.empty": "This user doesn't follow anyone yet.",
  "account.follows_you": "Follows you",
  "account.go_to_profile": "Go to profile",
  "account.hame.invalid_handle": "Handle unavailable",
  "account.in_memoriam": "In Memoriam.",
  "account.join_modal.day": "Day",
  "account.join_modal.me": "You joined {server} on",
  "account.join_modal.me_anniversary": "Happy Fediversary! You joined {server} on",
  "account.join_modal.me_today": "It’s your first day on {server}!",
  "account.join_modal.other": "{name} joined {server} on",
  "account.join_modal.other_today": "It’s {name}’s first day on {server}!",
  "account.join_modal.share.celebrate": "Share a celebratory post",
  "account.join_modal.share.intro": "Share an intro post",
  "account.join_modal.share.welcome": "Share a welcome post",
  "account.join_modal.years": "{number, plural, one {year} other {years}}",
  "account.joined_short": "Joined",
  "account.languages": "Change subscribed languages",
  "account.last_active": "Last active",
  "account.link_verified_on": "Ownership of this link was checked on {date}",
  "account.locked_info": "This account privacy status is set to locked. The owner manually reviews who can follow them.",
  "account.media": "Media",
  "account.menu.add_to_collection": "Add to collection…",
  "account.menu.add_to_list": "Add to list…",
  "account.menu.block": "Block account",
  "account.menu.block_domain": "Block {domain}",
  "account.menu.copied": "Copied account link to clipboard",
  "account.menu.copy": "Copy link",
  "account.menu.direct": "Privately mention",
  "account.menu.hide_reblogs": "Hide boosts in timeline",
  "account.menu.mention": "Mention",
  "account.menu.message": "Message",
  "account.menu.mute": "Mute account",
  "account.menu.note.description": "Visible only to you",
  "account.menu.open_original_page": "View on {domain}",
  "account.menu.open_original_page_no_domain": "View on original server",
  "account.menu.remove_follower": "Remove follower",
  "account.menu.report": "Report account",
  "account.menu.share": "Share…",
  "account.menu.show_reblogs": "Show boosts in timeline",
  "account.menu.unblock": "Unblock account",
  "account.menu.unblock_domain": "Unblock {domain}",
  "account.menu.unmute": "Unmute account",
  "account.moved_to": "{name} has indicated that their new account is now:",
  "account.mute": "Mute @{name}",
  "account.mute_notifications_short": "Mute notifications",
  "account.mute_short": "Mute",
  "account.muted": "Muted",
  "account.mutual": "You follow each other",
  "account.name.copy": "Copy handle",
  "account.name.help.domain": "{domain} is the server that hosts the user’s profile and posts.",
  "account.name.help.domain_self": "{domain} is your server that hosts your profile and posts.",
  "account.name.help.footer": "Just like you can send emails to people using different email providers, you can interact with people on other Mastodon servers, and with anyone on other Fediverse apps.",
  "account.name.help.header": "A handle is like an email address",
  "account.name.help.invalid_explanation": "This can happen when a user changes username, and is generally temporary. If this persists, it may be because of an unavailable server or some misconfiguration on their end.",
  "account.name.help.invalid_header": "This user's handle is being updated",
  "account.name.help.username": "{username} is this account’s username on their server. Someone on another server might have the same username.",
  "account.name.help.username_self": "{username} is your username on this server. Someone on another server might have the same username.",
  "account.name_info": "What does this mean?",
  "account.no_bio": "No description provided.",
  "account.node_modal.callout": "Personal notes are visible only to you.",
  "account.node_modal.edit_title": "Edit personal note",
  "account.node_modal.error_unknown": "Could not save the note",
  "account.node_modal.field_label": "Personal Note",
  "account.node_modal.save": "Save",
  "account.node_modal.title": "Add a personal note",
  "account.note.edit_button": "Edit",
  "account.note.title": "Personal note (visible only to you)",
  "account.open_original_page": "Open original page",
  "account.pending": "Pending",
  "account.posts": "Posts",
  "account.requested_follow": "{name} has requested to follow you",
  "account.share": "Share @{name}'s profile",
  "account.statuses_counter": "{count, plural, one {{counter} post} other {{counter} posts}}",
  "account.timeline.pinned": "Pinned",
  "account.timeline.pinned.view_all": "View all pinned posts",
  "account.unblock": "Unblock @{name}",
  "account.unblock_domain": "Unblock domain {domain}",
  "account.unblock_domain_short": "Unblock",
  "account.unblock_short": "Unblock",
  "account.unendorse": "Don't feature on profile",
  "account.unfollow": "Unfollow",
  "account.unmute": "Unmute @{name}",
  "account.unmute_notifications_short": "Unmute notifications",
  "account.unmute_short": "Unmute",
  "account_edit.advanced_settings.bot_hint": "Signal to others that the account mainly performs automated actions and might not be monitored",
  "account_edit.advanced_settings.bot_label": "Automated account",
  "account_edit.advanced_settings.title": "Advanced settings",
  "account_edit.bio.add_label": "Add bio",
  "account_edit.bio.edit_label": "Edit bio",
  "account_edit.bio.placeholder": "Add a short introduction to help others identify you.",
  "account_edit.bio.title": "Bio",
  "account_edit.bio_modal.add_title": "Add bio",
  "account_edit.bio_modal.edit_title": "Edit bio",
  "account_edit.column_button": "Done",
  "account_edit.column_title": "Edit Profile",
  "account_edit.custom_fields.add_label": "Add field",
  "account_edit.custom_fields.edit_label": "Edit field",
  "account_edit.custom_fields.placeholder": "Add your pronouns, external links, or anything else you’d like to share.",
  "account_edit.custom_fields.reorder_button": "Reorder fields",
  "account_edit.custom_fields.tip_content": "You can easily add credibility to your Mastodon account by verifying links to any websites you own.",
  "account_edit.custom_fields.tip_title": "Tip: Adding verified links",
  "account_edit.custom_fields.title": "Custom fields",
  "account_edit.custom_fields.verified_hint": "How do I add a verified link?",
  "account_edit.display_name.add_label": "Add display name",
  "account_edit.display_name.edit_label": "Edit display name",
  "account_edit.display_name.placeholder": "Your display name is how your name appears on your profile and in timelines.",
  "account_edit.display_name.title": "Display name",
  "account_edit.featured_hashtags.edit_label": "Add hashtags",
  "account_edit.featured_hashtags.placeholder": "Help others identify, and have quick access to, your favorite topics.",
  "account_edit.featured_hashtags.title": "Featured hashtags",
  "account_edit.field_actions.delete": "Delete field",
  "account_edit.field_actions.edit": "Edit field",
  "account_edit.field_delete_modal.confirm": "Are you sure you want to delete this custom field? This action can’t be undone.",
  "account_edit.field_delete_modal.delete_button": "Delete",
  "account_edit.field_delete_modal.title": "Delete custom field?",
  "account_edit.field_edit_modal.add_title": "Add custom field",
  "account_edit.field_edit_modal.discard_confirm": "Discard",
  "account_edit.field_edit_modal.discard_message": "You have unsaved changes. Are you sure you want to discard them?",
  "account_edit.field_edit_modal.edit_title": "Edit custom field",
  "account_edit.field_edit_modal.length_warning": "Recommended character limit exceeded. Mobile users might not see your field in full.",
  "account_edit.field_edit_modal.link_emoji_warning": "We recommend against the use of custom emoji in combination with urls. Custom fields containing both will display as text only instead of as a link, in order to prevent user confusion.",
  "account_edit.field_edit_modal.name_hint": "E.g. “Personal website”",
  "account_edit.field_edit_modal.name_label": "Label",
  "account_edit.field_edit_modal.url_warning": "To add a link, please include {protocol} at the beginning.",
  "account_edit.field_edit_modal.value_hint": "E.g. “https://example.me”",
  "account_edit.field_edit_modal.value_label": "Value",
  "account_edit.field_reorder_modal.drag_cancel": "Dragging was cancelled. Field \"{item}\" was dropped.",
  "account_edit.field_reorder_modal.drag_end": "Field \"{item}\" was dropped.",
  "account_edit.field_reorder_modal.drag_instructions": "To rearrange custom fields, press space or enter. While dragging, use the arrow keys to move the field up or down. Press space or enter again to drop the field in its new position, or press escape to cancel.",
  "account_edit.field_reorder_modal.drag_move": "Field \"{item}\" was moved.",
  "account_edit.field_reorder_modal.drag_over": "Field \"{item}\" was moved over \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "Picked up field \"{item}\".",
  "account_edit.field_reorder_modal.handle_label": "Drag field \"{item}\"",
  "account_edit.field_reorder_modal.title": "Rearrange fields",
  "account_edit.image_alt_modal.add_title": "Add alt text",
  "account_edit.image_alt_modal.details_content": "DO: <ul> <li>Describe yourself as pictured</li> <li>Use third person language (e.g. “Alex” instead of “me”)</li> <li>Be succinct – a few words is often enough</li> </ul> DON’T: <ul> <li>Start with “Photo of” – it’s redundant for screen readers</li> </ul> EXAMPLE: <ul> <li>“Alex wearing a green shirt and glasses”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Tips: Alt text for profile photos",
  "account_edit.image_alt_modal.edit_title": "Edit alt text",
  "account_edit.image_alt_modal.text_hint": "Alt text helps screen reader users to understand your content.",
  "account_edit.image_alt_modal.text_label": "Alt text",
  "account_edit.image_delete_modal.confirm": "Are you sure you want to delete this image? This action can’t be undone.",
  "account_edit.image_delete_modal.delete_button": "Delete",
  "account_edit.image_delete_modal.title": "Delete image?",
  "account_edit.image_edit.add_button": "Add image",
  "account_edit.image_edit.alt_add_button": "Add alt text",
  "account_edit.image_edit.alt_edit_button": "Edit alt text",
  "account_edit.image_edit.remove_button": "Remove image",
  "account_edit.image_edit.replace_button": "Replace image",
  "account_edit.item_list.delete": "Delete {name}",
  "account_edit.item_list.edit": "Edit {name}",
  "account_edit.name_modal.add_title": "Add display name",
  "account_edit.name_modal.edit_title": "Edit display name",
  "account_edit.profile_tab.button_label": "Customize",
  "account_edit.profile_tab.hint.description": "These settings customize what users see on {server} in the official apps, but they may not apply to users on other servers and 3rd party apps.",
  "account_edit.profile_tab.hint.title": "Displays still vary",
  "account_edit.profile_tab.show_featured.description": "‘Featured’ is an optional tab where you can showcase other accounts.",
  "account_edit.profile_tab.show_featured.title": "Show ‘Featured’ tab",
  "account_edit.profile_tab.show_media.description": "‘Media’ is an optional tab that shows your posts containing images or videos.",
  "account_edit.profile_tab.show_media.title": "Show ‘Media’ tab",
  "account_edit.profile_tab.show_media_replies.description": "When enabled, Media tab shows both your posts and replies to other people’s posts.",
  "account_edit.profile_tab.show_media_replies.title": "Include replies on ‘Media’ tab",
  "account_edit.profile_tab.show_relations.description": "Shows accounts you follow and followers to other users in your profile. People will still be able to see if you are following them.",
  "account_edit.profile_tab.show_relations.title": "Show ‘Followers’ and ‘Following’",
  "account_edit.profile_tab.subtitle": "Customize how your profile is displayed.",
  "account_edit.profile_tab.title": "Profile display settings",
  "account_edit.save": "Save",
  "account_edit.upload_modal.back": "Back",
  "account_edit.upload_modal.done": "Done",
  "account_edit.upload_modal.next": "Next",
  "account_edit.upload_modal.step_crop.zoom": "Zoom",
  "account_edit.upload_modal.step_upload.button": "Browse files",
  "account_edit.upload_modal.step_upload.dragging": "Drop to upload",
  "account_edit.upload_modal.step_upload.header": "Choose an image",
  "account_edit.upload_modal.step_upload.hint": "WEBP, PNG, GIF or JPG format, up to {limit}MB.{br}Image will be scaled to {width}x{height}px.",
  "account_edit.upload_modal.title_add.avatar": "Add profile photo",
  "account_edit.upload_modal.title_add.header": "Add cover photo",
  "account_edit.upload_modal.title_replace.avatar": "Replace profile photo",
  "account_edit.upload_modal.title_replace.header": "Replace cover photo",
  "account_edit.verified_modal.details": "Add credibility to your Mastodon profile by verifying links to personal websites. Here’s how it works:",
  "account_edit.verified_modal.invisible_link.details": "Add the link to your header. The important part is rel=\"me\" which prevents impersonation on websites with user-generated content. You can even use a link tag in the header of the page instead of {tag}, but the HTML must be accessible without executing JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "How do I make the link invisible?",
  "account_edit.verified_modal.step1.header": "Copy the HTML code below and paste into the header of your website",
  "account_edit.verified_modal.step2.details": "If you’ve already added your website as a custom field, you’ll need to delete and re-add it to trigger verification.",
  "account_edit.verified_modal.step2.header": "Add your website as a custom field",
  "account_edit.verified_modal.title": "How to add a verified link",
  "account_edit_tags.add_tag": "Add #{tagName}",
  "account_edit_tags.column_title": "Edit Tags",
  "account_edit_tags.help_text": "Featured hashtags help users discover and interact with your profile. They appear as filters on your Profile page’s Activity view.",
  "account_edit_tags.max_tags_reached": "You have reached the maximum number of featured hashtags.",
  "account_edit_tags.search_placeholder": "Enter a hashtag…",
  "account_edit_tags.suggestions": "Suggestions:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# post} other {# posts}}",
  "account_list.hidden_notice": "This is only visible to you. To show this list to others, go to <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# account} other {# accounts}}",
  "admin.dashboard.daily_retention": "User retention rate by day after sign-up",
  "admin.dashboard.monthly_retention": "User retention rate by month after sign-up",
  "admin.dashboard.retention.average": "Average",
  "admin.dashboard.retention.cohort": "Sign-up month",
  "admin.dashboard.retention.cohort_size": "New users",
  "admin.impact_report.instance_accounts": "Accounts profiles this would delete",
  "admin.impact_report.instance_followers": "Followers our users would lose",
  "admin.impact_report.instance_follows": "Followers their users would lose",
  "admin.impact_report.title": "Impact summary",
  "alert.need_reload.message": "Mastodon has been updated. Some things may not work correctly until you reload the page.",
  "alert.rate_limited.message": "Please retry after {retry_time, time, medium}.",
  "alert.rate_limited.title": "Rate limited",
  "alert.unexpected.message": "An unexpected error occurred.",
  "alert.unexpected.title": "Oops!",
  "alt_text_badge.title": "Alt text",
  "alt_text_modal.add_alt_text": "Add alt text",
  "alt_text_modal.add_text_from_image": "Add text from image",
  "alt_text_modal.cancel": "Cancel",
  "alt_text_modal.change_thumbnail": "Change thumbnail",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Describe this for people with hearing impairments…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Describe this for people with visual impairments…",
  "alt_text_modal.done": "Done",
  "announcement.announcement": "Announcement",
  "annual_report.announcement.action_build": "Build my Wrapstodon",
  "annual_report.announcement.action_dismiss": "No thanks",
  "annual_report.announcement.action_view": "View my Wrapstodon",
  "annual_report.announcement.description": "Discover more about your engagement on Mastodon over the past year.",
  "annual_report.announcement.title": "Wrapstodon {year} has arrived",
  "annual_report.nav_item.badge": "New",
  "annual_report.shared_page.donate": "Donate",
  "annual_report.shared_page.footer": "Generated with {heart} by the Mastodon team",
  "annual_report.shared_page.footer_server_info": "{username} uses {domain}, one of many communities powered by Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} stayed on the hunt for posts to boost, amplifying other creators with perfect aim.",
  "annual_report.summary.archetype.booster.desc_self": "You stayed on the hunt for posts to boost, amplifying other creators with perfect aim.",
  "annual_report.summary.archetype.booster.name": "The Archer",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "We know {name} was out there, somewhere, enjoying Mastodon in their own quiet way.",
  "annual_report.summary.archetype.lurker.desc_self": "We know you were out there, somewhere, enjoying Mastodon in your own quiet way.",
  "annual_report.summary.archetype.lurker.name": "The Stoic",
  "annual_report.summary.archetype.oracle.desc_public": "{name} created new posts more than replies, keeping Mastodon fresh and future-facing.",
  "annual_report.summary.archetype.oracle.desc_self": "You created new posts more than replies, keeping Mastodon fresh and future-facing.",
  "annual_report.summary.archetype.oracle.name": "The Oracle",
  "annual_report.summary.archetype.pollster.desc_public": "{name} created more polls than other post types, cultivating curiosity on Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "You created more polls than other post types, cultivating curiosity on Mastodon.",
  "annual_report.summary.archetype.pollster.name": "The Wonderer",
  "annual_report.summary.archetype.replier.desc_public": "{name} frequently replied to other people’s posts, pollinating Mastodon with new discussions.",
  "annual_report.summary.archetype.replier.desc_self": "You frequently replied to other people’s posts, pollinating Mastodon with new discussions.",
  "annual_report.summary.archetype.replier.name": "The Butterfly",
  "annual_report.summary.archetype.reveal": "Reveal my archetype",
  "annual_report.summary.archetype.reveal_description": "Thanks for being part of Mastodon! Time to find out which archetype you embodied in {year}.",
  "annual_report.summary.archetype.title_public": "{name}'s archetype",
  "annual_report.summary.archetype.title_self": "Your archetype",
  "annual_report.summary.close": "Close",
  "annual_report.summary.copy_link": "Copy link",
  "annual_report.summary.followers.new_followers": "{count, plural, one {new follower} other {new followers}}",
  "annual_report.summary.highlighted_post.boost_count": "This post was boosted {count, plural, one {once} other {# times}}.",
  "annual_report.summary.highlighted_post.favourite_count": "This post was favorited {count, plural, one {once} other {# times}}.",
  "annual_report.summary.highlighted_post.reply_count": "This post got {count, plural, one {one reply} other {# replies}}.",
  "annual_report.summary.highlighted_post.title": "Most popular post",
  "annual_report.summary.most_used_app.most_used_app": "most used app",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "most used hashtag",
  "annual_report.summary.most_used_hashtag.used_count": "You included this hashtag in {count, plural, one {one post} other {# posts}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} included this hashtag in {count, plural, one {one post} other {# posts}}.",
  "annual_report.summary.new_posts.new_posts": "new posts",
  "annual_report.summary.percentile.text": "<topLabel>That puts you in the top</topLabel><percentage></percentage><bottomLabel>of {domain} users.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "We won't tell Bernie.",
  "annual_report.summary.share_elsewhere": "Share elsewhere",
  "annual_report.summary.share_message": "I got the {archetype} archetype!",
  "annual_report.summary.share_on_mastodon": "Share on Mastodon",
  "attachments_list.unprocessed": "(unprocessed)",
  "audio.hide": "Hide audio",
  "block_modal.no_collections": "Neither of you can add each other to collections. You'll be automatically removed from each others' existing collections, if applicable.",
  "block_modal.remote_users_caveat": "We will ask the server {domain} to respect your decision. However, compliance is not guaranteed since some servers may handle blocks differently. Public posts may still be visible to non-logged-in users.",
  "block_modal.show_less": "Show less",
  "block_modal.show_more": "Show more",
  "block_modal.they_cant_mention": "You can't mention, follow, or quote each other.",
  "block_modal.they_cant_see_posts": "They can't see your content and you won't see theirs.",
  "block_modal.they_will_know": "They can see that they're blocked.",
  "block_modal.title": "Block user?",
  "block_modal.you_wont_see_mentions": "You won't see posts from others that mention them.",
  "boost_modal.combo": "You can press {combo} to skip this next time",
  "boost_modal.reblog": "Boost post?",
  "boost_modal.undo_reblog": "Unboost post?",
  "bundle_column_error.copy_stacktrace": "Copy error report",
  "bundle_column_error.error.body": "The requested page could not be rendered. It could be due to a bug in our code, or a browser compatibility issue.",
  "bundle_column_error.error.title": "Oh, no!",
  "bundle_column_error.network.body": "There was an error when trying to load this page. This could be due to a temporary problem with your internet connection or this server.",
  "bundle_column_error.network.title": "Network error",
  "bundle_column_error.retry": "Try again",
  "bundle_column_error.return": "Go back home",
  "bundle_column_error.routing.body": "The requested page could not be found. Are you sure the URL in the address bar is correct?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Close",
  "bundle_modal_error.message": "Something went wrong while loading this screen.",
  "bundle_modal_error.retry": "Try again",
  "callout.dismiss": "Dismiss",
  "card.delete": "Remove this",
  "carousel.current": "<sr>Slide</sr> {current, number} / {max, number}",
  "carousel.slide": "Slide {current, number} of {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} recommended characters",
  "character_counter.required": "{currentLength}/{maxLength} characters",
  "closed_registrations.other_server_instructions": "Since Mastodon is decentralized, you can create an account on another server and still interact with this one.",
  "closed_registrations_modal.description": "Creating an account on {domain} is currently not possible, but please keep in mind that you do not need an account specifically on {domain} to use Mastodon.",
  "closed_registrations_modal.find_another_server": "Find another server",
  "closed_registrations_modal.preamble": "Mastodon is decentralized, so no matter where you create your account, you will be able to follow and interact with anyone on this server. You can even self-host it!",
  "closed_registrations_modal.title": "Signing up on Mastodon",
  "collection.share_modal.share_link_label": "Share link",
  "collection.share_modal.share_via_post": "Post on Mastodon",
  "collection.share_modal.share_via_system": "Share to…",
  "collection.share_modal.title": "Share collection",
  "collection.share_modal.title_new": "Share your new collection!",
  "collection.share_template_other": "Check out this cool collection:",
  "collection.share_template_own": "Check out my new collection:",
  "collections.account_count": "{count, plural, one {# account} other {# accounts}}",
  "collections.accounts.empty_description": "Add up to {count} accounts",
  "collections.accounts.empty_editor_title": "No one is in this collection yet",
  "collections.accounts.empty_title": "This collection is empty",
  "collections.add_to_collection": "Add {name} to collections",
  "collections.block_collection_owner": "Block account",
  "collections.by_account": "by {account_handle}",
  "collections.collection_description": "Description",
  "collections.collection_language": "Language",
  "collections.collection_language_none": "None",
  "collections.collection_name": "Name",
  "collections.collection_topic": "Topic",
  "collections.confirm_account_removal": "Are you sure you want to remove this account from this collection?",
  "collections.content_warning": "Content warning",
  "collections.continue": "Continue",
  "collections.copy_link": "Copy link",
  "collections.copy_link_confirmation": "Copied collection link to clipboard",
  "collections.create.accounts_title": "Who will you feature in this collection?",
  "collections.create.basic_details_title": "Basic details",
  "collections.create.steps": "Step {step}/{total}",
  "collections.create_collection": "Create collection",
  "collections.create_new_collection": "Create new collection",
  "collections.delete_collection": "Delete collection",
  "collections.description_length_hint": "100 characters limit",
  "collections.detail.author_added_you_on_date": "{author} added you on {date}",
  "collections.detail.loading": "Loading collection…",
  "collections.detail.revoke_inclusion": "Remove me",
  "collections.detail.sensitive_content": "Sensitive content",
  "collections.detail.sensitive_note": "The description and accounts may not be suitable for all viewers.",
  "collections.detail.share": "Share this collection",
  "collections.detail.you_are_in_this_collection": "You're featured in this collection",
  "collections.edit_details": "Edit details",
  "collections.error_loading_collections": "There was an error when trying to load these collections.",
  "collections.hidden_accounts_description": "You’ve blocked or muted {count, plural, one {this user} other {these users}}",
  "collections.hidden_accounts_link": "{count, plural, one {# hidden account} other {# hidden accounts}}",
  "collections.hints.accounts_counter": "{count}/{max} accounts",
  "collections.last_updated_at": "Last updated: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# Collection} other {# Collections}}",
  "collections.list.created_by_author": "Created by {name}",
  "collections.list.created_by_you": "Created by you",
  "collections.list.featuring_you": "Featuring you",
  "collections.manage_accounts": "Manage accounts",
  "collections.mark_as_sensitive": "Mark as sensitive",
  "collections.mark_as_sensitive_hint": "Hides the collection's description and accounts behind a content warning. The collection name will still be visible.",
  "collections.maximum_collection_count_description": "Your server allows creation of up to {count} collections.",
  "collections.maximum_collection_count_reached": "You have created the maximum number of collections",
  "collections.name_length_hint": "40 characters limit",
  "collections.new_collection": "New collection",
  "collections.pending_accounts.message": "Accounts may appear as pending when we’re awaiting a response from the user or their server. Only you can see pending accounts.",
  "collections.pending_accounts.title": "Why am I seeing pending accounts?",
  "collections.remove_account": "Remove",
  "collections.report_collection": "Report this collection",
  "collections.revoke_collection_inclusion": "Remove myself from this collection",
  "collections.revoke_inclusion.confirmation": "You've been removed from \"{collection}\"",
  "collections.revoke_inclusion.error": "There was an error, please try again later.",
  "collections.search_accounts_label": "Search for an account to add",
  "collections.search_accounts_max_reached": "You have added the maximum number of accounts",
  "collections.sensitive": "Sensitive",
  "collections.share_short": "Share",
  "collections.sort_alphabetical": "Alphabetical",
  "collections.sort_by": "Sort by:",
  "collections.sort_date_added": "Date added",
  "collections.sort_last_active": "Last active",
  "collections.sort_most_followers": "Most followers",
  "collections.suggestions.can_not_add": "Can’t be added",
  "collections.suggestions.can_not_add_desc": "These accounts may have opted out of discovery, or they might be on a server that doesn’t support collections.",
  "collections.suggestions.must_follow": "Must follow first",
  "collections.suggestions.must_follow_desc": "These accounts review all follow requests. Followers can add them to collections.",
  "collections.topic_hint": "Add a hashtag that helps others understand the main topic of this collection.",
  "collections.topic_special_chars_hint": "Special characters will be removed when saving",
  "collections.unlisted_collections_description": "These don’t appear on your profile to others. Anyone with the link can discover them.",
  "collections.unlisted_collections_with_count": "Unlisted collections ({count})",
  "collections.view_collection": "View collection",
  "collections.visibility_public": "Public",
  "collections.visibility_public_hint": "Discoverable in search results and other areas where recommendations appear.",
  "collections.visibility_title": "Visibility",
  "collections.visibility_unlisted": "Unlisted",
  "collections.visibility_unlisted_hint": "Visible to anyone with a link. Hidden from search results and recommendations.",
  "column.about": "About",
  "column.blocked_accounts": "Blocked Accounts",
  "column.blocks": "Blocked users",
  "column.bookmarks": "Bookmarks",
  "column.community": "Local timeline",
  "column.create_list": "Create list",
  "column.direct": "Private mentions",
  "column.directory": "Browse profiles",
  "column.domain_blocks": "Blocked domains",
  "column.edit_list": "Edit list",
  "column.favourites": "Favorites",
  "column.firehose": "Live feeds",
  "column.firehose_local": "Live feed for this server",
  "column.firehose_singular": "Live feed",
  "column.follow_requests": "Follow requests",
  "column.following": "Following",
  "column.following_settings": "Following Feed Settings",
  "column.has_unread_content": "(has unread content)",
  "column.home": "Home",
  "column.list_members": "Manage list members",
  "column.lists": "Lists",
  "column.mutes": "Muted users",
  "column.notifications": "Notifications",
  "column.other_collections": "Collections by {name}",
  "column.pins": "Pinned posts",
  "column.public": "Federated timeline",
  "column.saved_posts": "Saved Posts",
  "column.settings": "Column Settings",
  "column.your_collections": "Your Collections",
  "column_back_button.label": "Back",
  "column_header.hide_settings": "Hide settings",
  "column_header.moveLeft_settings": "Move column to the left",
  "column_header.moveRight_settings": "Move column to the right",
  "column_header.move_column_left": "Move column left",
  "column_header.move_column_right": "Move column right",
  "column_header.pin": "Pin",
  "column_header.pin_column": "Pin column",
  "column_header.show_settings": "Show settings",
  "column_header.unpin": "Unpin",
  "column_header.unpin_column": "Unpin column",
  "column_search.cancel": "Cancel",
  "combobox.close_results": "Close results",
  "combobox.loading": "Loading",
  "combobox.no_results_found": "No results for this search",
  "combobox.open_results": "Open results",
  "combobox.results_available": "{count, plural, one {# suggestion} other {# suggestions}} available. Use up and down arrow keys to navigate. Press Enter key to select.",
  "community.column_settings.local_only": "Local only",
  "community.column_settings.media_only": "Media Only",
  "community.column_settings.remote_only": "Remote only",
  "compose.cancel_modal.body": "You have a draft already in progress. What would you like to do?",
  "compose.cancel_modal.continue": "Continue draft",
  "compose.cancel_modal.delete": "Delete draft",
  "compose.cancel_modal.title": "Discard draft",
  "compose.counter": "{current, number}/{max, number}",
  "compose.discoverable": "Discoverable in public feeds & search results",
  "compose.error.blank_post": "Post can't be blank.",
  "compose.expand": "Show composer",
  "compose.hints.followers-reply": "You're replying to a followers-only post. People not following {user} might see your reply without the context of what you’re replying to.",
  "compose.hints.language": "Change this post’s language to {language}?",
  "compose.hints.language.change": "Change",
  "compose.hints.language.dismiss": "Dismiss",
  "compose.hints.missing-alt": "Your attachment is missing alt text.",
  "compose.hints.missing-alt-many": "One or more of your attachments are missing alt text.",
  "compose.language.change": "Change language",
  "compose.language.not-found": "No language found",
  "compose.language.search": "Search languages...",
  "compose.message.direct.followers": "{name} {count, plural, =0 {} one {+ # other} other {+ # others}}",
  "compose.message.notice": "Messages are not end-to-end encrypted",
  "compose.message.placeholder": "Add your recipients and your message.",
  "compose.message.publish": "Send",
  "compose.minimize": "Minimize composer",
  "compose.new": "Write a new post or messsage",
  "compose.new.message": "Message",
  "compose.new.post": "Post",
  "compose.poll.add": "Add another option",
  "compose.poll.delete": "Delete poll",
  "compose.poll.duration": "Duration:",
  "compose.poll.multiple": "Allow multiple selections",
  "compose.post.placeholder": "What would you like to say?",
  "compose.post.privacy.followers": "Followers {count, plural, =0 {} one {+ # other} other {+ # others}}",
  "compose.post.title.edit": "Edit post",
  "compose.post.title.new": "New post",
  "compose.post.to": "To:",
  "compose.post.to_message": "Compose a message instead",
  "compose.publish": "Publish",
  "compose.published.body": "Post published.",
  "compose.published.open": "Open",
  "compose.quotable": "Allow others to quote",
  "compose.quote.audio": "Audio file {duration}",
  "compose.quote.poll": "Poll {sep} {isOpen, select, open {Accepting responses} other {Closed}}",
  "compose.quote.spoiler": "Content:",
  "compose.rearrange_modal.cancel": "Cancel",
  "compose.rearrange_modal.drag_cancel": "Dragging was cancelled. Attachment index {item, number} was dropped.",
  "compose.rearrange_modal.drag_end": "Attachment index {item, number} was moved to index {over, number}.",
  "compose.rearrange_modal.drag_instructions": "To rearrange attachments, press space or enter. While dragging, use the arrow keys to move the attachment up or down. Press space or enter again to drop the attachment in its new position, or press escape to cancel.",
  "compose.rearrange_modal.drag_move": "Attachment index {item, number} was moved.",
  "compose.rearrange_modal.drag_over": "Attachment index {item, number} was moved over index {over, number}.",
  "compose.rearrange_modal.drag_start": "Picked up attachment at index {item, number}.",
  "compose.rearrange_modal.handle": "Drag attachment at position {index, number}",
  "compose.rearrange_modal.save": "Save",
  "compose.rearrange_modal.title": "Rearrange media",
  "compose.reply.title.new": "New reply",
  "compose.saved.body": "Post saved.",
  "compose.sensitive": "Sensitive",
  "compose.sensitive.text": "Sensitive content description",
  "compose.switch_modal.back": "Back",
  "compose.switch_modal.body": "Your message has limited visibility. If you convert to a post, it will switch to your default post visibility.",
  "compose.switch_modal.continue": "Continue",
  "compose.switch_modal.title": "Convert to post?",
  "compose.upload.alt": "Alt",
  "compose.upload.audio.delete": "Remove audio",
  "compose.upload.menu": "Add alt text or remove the image",
  "compose.upload.menu.add_alt": "Add alt text",
  "compose.upload.menu.delete": "Remove image",
  "compose.upload.menu.edit_alt": "Edit alt text",
  "compose.upload.menu.rearrange": "Rearrange…",
  "compose.visibility.direct_note": "Everyone mentioned",
  "compose.visibility.quote_policy": "Who can quote",
  "compose.visibility.quote_policy.anyone": "Anyone",
  "compose.visibility.quote_policy.followers": "Followers",
  "compose.visibility.title": "Visibility",
  "compose.visibility.to_post": "Compose a post instead",
  "compose_form.direct_message_warning_learn_more": "Learn more",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any sensitive information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is not public. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer": "Your account is not {locked}. Anyone can follow you to view your follower-only posts.",
  "compose_form.lock_disclaimer.lock": "locked",
  "compose_form.message.title.edit": "Edit message",
  "compose_form.message.title.new": "New message",
  "compose_form.placeholder": "What's on your mind?",
  "compose_form.poll.duration": "Poll duration",
  "compose_form.poll.multiple": "Multiple choice",
  "compose_form.poll.option_placeholder": "Option {number}",
  "compose_form.poll.single": "Single choice",
  "compose_form.poll.switch_to_multiple": "Change poll to allow multiple choices",
  "compose_form.poll.switch_to_single": "Change poll to allow for a single choice",
  "compose_form.poll.type": "Style",
  "compose_form.publish": "Post",
  "compose_form.reply": "Reply",
  "compose_form.reply.title.edit": "Edit reply",
  "compose_form.save_changes": "Update",
  "compose_form.spoiler.marked": "Remove content warning",
  "compose_form.spoiler.unmarked": "Add content warning",
  "compose_form.spoiler_placeholder": "Content warning (optional)",
  "confirmation_modal.cancel": "Cancel",
  "confirmations.block.confirm": "Block",
  "confirmations.delete.confirm": "Delete",
  "confirmations.delete.message": "Are you sure you want to delete this post?",
  "confirmations.delete.title": "Delete post?",
  "confirmations.delete_collection.confirm": "Delete",
  "confirmations.delete_collection.message": "This action cannot be undone.",
  "confirmations.delete_collection.title": "Delete \"{name}\"?",
  "confirmations.delete_list.confirm": "Delete",
  "confirmations.delete_list.message": "Are you sure you want to permanently delete this list?",
  "confirmations.delete_list.title": "Delete list?",
  "confirmations.discard_draft.confirm": "Discard and continue",
  "confirmations.discard_draft.edit.cancel": "Resume editing",
  "confirmations.discard_draft.edit.message": "Continuing will discard any changes you have made to the post you are currently editing.",
  "confirmations.discard_draft.edit.title": "Discard changes to your post?",
  "confirmations.discard_draft.post.cancel": "Resume draft",
  "confirmations.discard_draft.post.message": "Continuing will discard the post you are currently composing.",
  "confirmations.discard_draft.post.title": "Discard your draft post?",
  "confirmations.discard_edit_media.confirm": "Discard",
  "confirmations.discard_edit_media.message": "You have unsaved changes to the media description or preview, discard them anyway?",
  "confirmations.follow_to_list.confirm": "Follow and add to list",
  "confirmations.follow_to_list.message": "You need to be following {name} to add them to a list.",
  "confirmations.follow_to_list.title": "Follow user?",
  "confirmations.hide_featured_tab.confirm": "Hide tab",
  "confirmations.hide_featured_tab.intro": "You can change this at any time under <i>Edit profile > Profile tab settings</i>.",
  "confirmations.hide_featured_tab.message": "This will hide the tab for users on {serverName} and other servers running the latest version of Mastodon. Other displays may vary.",
  "confirmations.hide_featured_tab.title": "Hide \"Featured\" tab?",
  "confirmations.logout.confirm": "Log out",
  "confirmations.logout.message": "Are you sure you want to log out?",
  "confirmations.logout.title": "Log out?",
  "confirmations.missing_alt_text.confirm": "Add alt text",
  "confirmations.missing_alt_text.message": "Your post contains media without alt text. Adding descriptions helps make your content accessible to more people.",
  "confirmations.missing_alt_text.secondary": "Post anyway",
  "confirmations.missing_alt_text.title": "Add alt text?",
  "confirmations.mute.confirm": "Mute",
  "confirmations.private_quote_notify.cancel": "Back to editing",
  "confirmations.private_quote_notify.confirm": "Publish post",
  "confirmations.private_quote_notify.do_not_show_again": "Don't show me this message again",
  "confirmations.private_quote_notify.message": "The person you are quoting and other mentions will be notified and will be able to view your post, even if they're not following you.",
  "confirmations.private_quote_notify.title": "Share with followers and mentioned users?",
  "confirmations.quiet_post_quote_info.dismiss": "Don't remind me again",
  "confirmations.quiet_post_quote_info.got_it": "Got it",
  "confirmations.quiet_post_quote_info.message": "When quoting a quiet public post, your post will be hidden from trending timelines.",
  "confirmations.quiet_post_quote_info.title": "Quoting quiet public posts",
  "confirmations.redraft.confirm": "Delete & redraft",
  "confirmations.redraft.message": "Are you sure you want to delete this post and re-draft it? Favorites and boosts will be lost, and replies to the original post will be orphaned.",
  "confirmations.redraft.title": "Delete & redraft post?",
  "confirmations.remove_from_followers.confirm": "Remove follower",
  "confirmations.remove_from_followers.message": "{name} will stop following you. Are you sure you want to proceed?",
  "confirmations.remove_from_followers.title": "Remove follower?",
  "confirmations.revoke_collection_inclusion.confirm": "Remove me",
  "confirmations.revoke_collection_inclusion.message": "The curator won't be able to re-add you to this collection for 24 hours. To prevent them from adding you to collections permanently, you can block them.",
  "confirmations.revoke_collection_inclusion.title": "Remove yourself from this collection?",
  "confirmations.revoke_quote.confirm": "Remove post",
  "confirmations.revoke_quote.message": "This action cannot be undone.",
  "confirmations.revoke_quote.title": "Remove post?",
  "confirmations.unblock.confirm": "Unblock",
  "confirmations.unblock.title": "Unblock {name}?",
  "confirmations.unfollow.confirm": "Unfollow",
  "confirmations.unfollow.title": "Unfollow {name}?",
  "confirmations.withdraw_request.confirm": "Withdraw request",
  "confirmations.withdraw_request.title": "Withdraw request to follow {name}?",
  "content_warning.hide": "Hide post",
  "content_warning.show": "Show anyway",
  "content_warning.show_more": "Show more",
  "content_warning.show_short": "Show",
  "conversation.delete": "Delete conversation",
  "conversation.mark_as_read": "Mark as read",
  "conversation.open": "View conversation",
  "conversation.with": "With {names}",
  "copy_icon_button.copied": "Copied to clipboard",
  "copy_icon_button.copy_this_text": "Copy link to clipboard",
  "copypaste.copied": "Copied",
  "copypaste.copy_to_clipboard": "Copy to clipboard",
  "custom_homepage.about": "About",
  "custom_homepage.about_this_server": "About this server",
  "custom_homepage.administered_by": "Administered by",
  "custom_homepage.contact": "Contact:",
  "custom_homepage.latest_activity": "Latest activity",
  "custom_homepage.these_are_the_latest_posts": "These are the latest 40 posts from accounts on this server.",
  "directory.federated": "From known fediverse",
  "directory.local": "From {domain} only",
  "directory.new_arrivals": "New arrivals",
  "directory.recently_active": "Recently active",
  "disabled_account_banner.account_settings": "Account settings",
  "disabled_account_banner.text": "Your account {disabledAccount} is currently disabled.",
  "dismissable_banner.community_timeline": "These are the most recent public posts from people whose accounts are hosted by {domain}.",
  "dismissable_banner.dismiss": "Dismiss",
  "dismissable_banner.public_timeline": "These are the most recent public posts from people on the fediverse that people on {domain} follow.",
  "domain_block_modal.block": "Block server",
  "domain_block_modal.block_account_instead": "Block @{name} instead",
  "domain_block_modal.they_can_interact_with_old_posts": "People from this server can interact with your old posts.",
  "domain_block_modal.they_cant_follow": "Nobody from this server can follow you.",
  "domain_block_modal.they_wont_know": "They won't know they've been blocked.",
  "domain_block_modal.title": "Block domain?",
  "domain_block_modal.you_will_lose_num_followers": "You will lose {followersCount, plural, one {{followersCountDisplay} follower} other {{followersCountDisplay} followers}} and {followingCount, plural, one {{followingCountDisplay} person you follow} other {{followingCountDisplay} people you follow}}.",
  "domain_block_modal.you_will_lose_relationships": "You will lose all followers and people you follow from this server.",
  "domain_block_modal.you_wont_see_posts": "You won't see posts or notifications from users on this server.",
  "dropdown.empty": "Select an option",
  "email_subscriptions.email": "Email",
  "email_subscriptions.form.action": "Subscribe",
  "email_subscriptions.form.bottom": "Get posts in your inbox without creating a Mastodon account. Unsubscribe at any time. For more information, refer to the <a>Privacy Policy</a>.",
  "email_subscriptions.form.title": "Sign up for email updates from {name}",
  "email_subscriptions.submitted.lead": "Check your inbox for an email to finish signing up for email updates.",
  "email_subscriptions.submitted.title": "One more step",
  "email_subscriptions.validation.email.blocked": "Blocked email provider",
  "email_subscriptions.validation.email.invalid": "Invalid email address",
  "embed.instructions": "Embed this post on your website by copying the code below.",
  "embed.preview": "Here is what it will look like:",
  "emoji_button.activity": "Activity",
  "emoji_button.clear": "Clear",
  "emoji_button.custom": "Custom",
  "emoji_button.flags": "Flags",
  "emoji_button.food": "Food & Drink",
  "emoji_button.label": "Insert emoji",
  "emoji_button.nature": "Nature",
  "emoji_button.not_found": "No matching emojis found",
  "emoji_button.objects": "Objects",
  "emoji_button.people": "People",
  "emoji_button.recent": "Frequently used",
  "emoji_button.search": "Search...",
  "emoji_button.search_results": "Search results",
  "emoji_button.symbols": "Symbols",
  "emoji_button.travel": "Travel & Places",
  "empty_column.account_featured.other": "{acct} has not featured anything yet.",
  "empty_column.account_featured_self.no_collections_button": "Create a collection",
  "empty_column.account_featured_self.no_collections_hide_tab": "Hide this tab instead",
  "empty_column.account_featured_self.showcase_accounts": "Showcase your favorite accounts",
  "empty_column.account_featured_self.showcase_accounts_desc": "Collections are curated lists of accounts to help others discover more of the Fediverse.",
  "empty_column.account_featured_unknown.other": "This account hasn’t featured anything yet.",
  "empty_column.account_hides_collections": "This user has chosen to not make this information available",
  "empty_column.account_suspended": "Account suspended",
  "empty_column.account_timeline": "No posts here!",
  "empty_column.account_unavailable": "Profile unavailable",
  "empty_column.blocks": "You haven't blocked any users yet.",
  "empty_column.bookmarked_statuses": "You don't have any bookmarked posts yet. When you bookmark one, it will show up here.",
  "empty_column.collections": "{acct} has not created any collections yet.",
  "empty_column.collections.featured_in": "You have not been added to any collections yet.",
  "empty_column.collections.featured_in_undiscoverable": "In order for people to add you to collections, you need to allow featuring in discovery experiences from <link>Preferences > Privacy and reach</link>",
  "empty_column.collections_self": "You have not created any collections yet.",
  "empty_column.community": "The local timeline is empty. Write something publicly to get the ball rolling!",
  "empty_column.direct": "You don't have any private mentions yet. When you send or receive one, it will show up here.",
  "empty_column.disabled_feed": "This feed has been disabled by your server administrators.",
  "empty_column.domain_blocks": "There are no blocked domains yet.",
  "empty_column.explore_statuses": "Nothing is trending right now. Check back later!",
  "empty_column.favourited_statuses": "You don't have any favorite posts yet. When you favorite one, it will show up here.",
  "empty_column.favourites": "No one has favorited this post yet. When someone does, they will show up here.",
  "empty_column.follow_requests": "You don't have any follow requests yet. When you receive one, it will show up here.",
  "empty_column.followed_tags": "You have not followed any hashtags yet. When you do, they will show up here.",
  "empty_column.hashtag": "There is nothing in this hashtag yet.",
  "empty_column.home": "Your home timeline is empty! Follow more people to fill it up.",
  "empty_column.list": "There is nothing in this list yet. When members of this list publish new posts, they will appear here.",
  "empty_column.mutes": "You haven't muted any users yet.",
  "empty_column.notification_requests": "All clear! There is nothing here. When you receive new notifications, they will appear here according to your settings.",
  "empty_column.notifications": "You don't have any notifications yet. When other people interact with you, you will see it here.",
  "empty_column.public": "There is nothing here! Write something publicly, or manually follow users from other servers to fill it up",
  "empty_state.no_results": "No results",
  "error.no_hashtag_feed_access": "Join or log in to view and follow this hashtag.",
  "error.unexpected_crash.explanation": "Due to a bug in our code or a browser compatibility issue, this page could not be displayed correctly.",
  "error.unexpected_crash.explanation_addons": "This page could not be displayed correctly. This error is likely caused by a browser add-on or automatic translation tools.",
  "error.unexpected_crash.next_steps": "Try refreshing the page. If that does not help, you may still be able to use Mastodon through a different browser or native app.",
  "error.unexpected_crash.next_steps_addons": "Try disabling them and refreshing the page. If that does not help, you may still be able to use Mastodon through a different browser or native app.",
  "errors.unexpected_crash.copy_stacktrace": "Copy stacktrace to clipboard",
  "errors.unexpected_crash.report_issue": "Report issue",
  "explore.suggested_follows": "People",
  "explore.title": "Trending",
  "explore.trending_links": "News",
  "explore.trending_statuses": "Posts",
  "explore.trending_tags": "Hashtags",
  "featured_carousel.current": "<sr>Post</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Pinned Post} other {Pinned Posts}}",
  "featured_carousel.slide": "Post {current, number} of {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Lately you’ve posted about {items}. Add these as featured hashtags?",
  "featured_tags.suggestions.add": "Add",
  "featured_tags.suggestions.added": "Manage your featured hashtags at any time under <link>Edit Profile > Featured hashtags</link>.",
  "featured_tags.suggestions.dismiss": "No thanks",
  "filter_modal.added.context_mismatch_explanation": "This filter category does not apply to the context in which you have accessed this post. If you want the post to be filtered in this context too, you will have to edit the filter.",
  "filter_modal.added.context_mismatch_title": "Context mismatch!",
  "filter_modal.added.expired_explanation": "This filter category has expired, you will need to change the expiration date for it to apply.",
  "filter_modal.added.expired_title": "Expired filter!",
  "filter_modal.added.review_and_configure": "To review and further configure this filter category, go to the {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Filter settings",
  "filter_modal.added.settings_link": "settings page",
  "filter_modal.added.short_explanation": "This post has been added to the following filter category: {title}.",
  "filter_modal.added.title": "Filter added!",
  "filter_modal.select_filter.context_mismatch": "does not apply to this context",
  "filter_modal.select_filter.expired": "expired",
  "filter_modal.select_filter.prompt_new": "New category: {name}",
  "filter_modal.select_filter.search": "Search or create",
  "filter_modal.select_filter.subtitle": "Use an existing category or create a new one",
  "filter_modal.select_filter.title": "Filter this post",
  "filter_modal.title.status": "Filter a post",
  "filter_warning.matches_filter": "Matches filter “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "From {count, plural, =0 {no one} one {one person} other {# people}} you may know",
  "filtered_notifications_banner.title": "Filtered notifications",
  "firehose.all": "All",
  "firehose.local": "This server",
  "firehose.remote": "Other servers",
  "follow_request.authorize": "Authorize",
  "follow_request.reject": "Reject",
  "follow_requests.unlocked_explanation": "Even though your account is not locked, the {domain} staff thought you might want to review follow requests from these accounts manually.",
  "follow_suggestions.curated_suggestion": "Staff pick",
  "follow_suggestions.dismiss": "Don't show again",
  "follow_suggestions.featured_longer": "Hand-picked by the {domain} team",
  "follow_suggestions.friends_of_friends_longer": "Popular among people you follow",
  "follow_suggestions.hints.featured": "This profile has been hand-picked by the {domain} team.",
  "follow_suggestions.hints.friends_of_friends": "This profile is popular among the people you follow.",
  "follow_suggestions.hints.most_followed": "This profile is one of the most followed on {domain}.",
  "follow_suggestions.hints.most_interactions": "This profile has been recently getting a lot of attention on {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "This profile is similar to the profiles you have most recently followed.",
  "follow_suggestions.personalized_suggestion": "Personalized suggestion",
  "follow_suggestions.popular_suggestion": "Popular suggestion",
  "follow_suggestions.popular_suggestion_longer": "Popular on {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Similar to profiles you recently followed",
  "follow_suggestions.view_all": "View all",
  "follow_suggestions.who_to_follow": "Who to follow",
  "followed_tags": "Followed hashtags",
  "followers.hide_other_followers": "This user has chosen to not make their other followers visible",
  "followers.title": "Following {name}",
  "following.hide_other_following": "This user has chosen to not make the rest of who they follow visible",
  "following.title": "Followed by {name}",
  "footer.about": "About",
  "footer.about_mastodon": "About Mastodon",
  "footer.about_server": "About {domain}",
  "footer.about_this_server": "About",
  "footer.directory": "Profiles directory",
  "footer.get_app": "Get the app",
  "footer.keyboard_shortcuts": "Keyboard shortcuts",
  "footer.privacy_policy": "Privacy policy",
  "footer.privacy_policy_short": "Privacy",
  "footer.source_code": "View source code",
  "footer.status": "Status",
  "footer.terms_of_service": "Terms of service",
  "footer.terms_of_service_short": "Terms",
  "form_error.blank": "Field cannot be blank.",
  "form_field.optional": "(optional)",
  "getting_started.heading": "Getting started",
  "hashtag.admin_moderation": "Open moderation interface for #{name}",
  "hashtag.browse": "Browse posts in #{hashtag}",
  "hashtag.browse_from_account": "Browse posts from @{name} in #{hashtag}",
  "hashtag.column_header.tag_mode.all": "and {additional}",
  "hashtag.column_header.tag_mode.any": "or {additional}",
  "hashtag.column_header.tag_mode.none": "without {additional}",
  "hashtag.column_settings.select.no_options_message": "No suggestions found",
  "hashtag.column_settings.select.placeholder": "Enter hashtags…",
  "hashtag.column_settings.tag_mode.all": "All of these",
  "hashtag.column_settings.tag_mode.any": "Any of these",
  "hashtag.column_settings.tag_mode.none": "None of these",
  "hashtag.column_settings.tag_toggle": "Include additional tags for this column",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} participant} other {{counter} participants}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} post} other {{counter} posts}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} post} other {{counter} posts}} today",
  "hashtag.feature": "Feature on profile",
  "hashtag.follow": "Follow hashtag",
  "hashtag.mute": "Mute #{hashtag}",
  "hashtag.unfeature": "Don't feature on profile",
  "hashtag.unfollow": "Unfollow hashtag",
  "hashtags.and_other": "…and {count, plural, other {# more}}",
  "hints.profiles.followers_may_be_missing": "Followers for this profile may be missing.",
  "hints.profiles.follows_may_be_missing": "Follows for this profile may be missing.",
  "hints.profiles.posts_may_be_missing": "Some posts from this profile may be missing.",
  "hints.profiles.see_more_followers": "See more followers on {domain}",
  "hints.profiles.see_more_follows": "See more follows on {domain}",
  "hints.profiles.see_more_posts": "See more posts on {domain}",
  "home.column_settings.show_quotes": "Show quotes",
  "home.column_settings.show_reblogs": "Show boosts",
  "home.column_settings.show_replies": "Show replies",
  "home.hide_announcements": "Hide announcements",
  "home.pending_critical_update.body": "Please update your Mastodon server as soon as possible!",
  "home.pending_critical_update.link": "See updates",
  "home.pending_critical_update.title": "Critical security update available!",
  "home.show_announcements": "Show announcements",
  "ignore_notifications_modal.bots_title": "Ignore notifications from bots?",
  "ignore_notifications_modal.disclaimer": "Mastodon cannot inform users that you've ignored their notifications. Ignoring notifications will not stop the messages themselves from being sent.",
  "ignore_notifications_modal.filter_instead": "Filter instead",
  "ignore_notifications_modal.filter_to_act_users": "You'll still be able to accept, reject, or report users",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtering helps avoid potential confusion",
  "ignore_notifications_modal.filter_to_review_separately": "You can review filtered notifications separately",
  "ignore_notifications_modal.ignore": "Ignore notifications",
  "ignore_notifications_modal.limited_accounts_title": "Ignore notifications from moderated accounts?",
  "ignore_notifications_modal.new_accounts_title": "Ignore notifications from new accounts?",
  "ignore_notifications_modal.not_followers_title": "Ignore notifications from people not following you?",
  "ignore_notifications_modal.not_following_title": "Ignore notifications from people you don't follow?",
  "ignore_notifications_modal.private_mentions_title": "Ignore notifications from unsolicited Private Mentions?",
  "info_button.label": "Help",
  "info_button.what_is_alt_text": "<h1>What is alt text?</h1> <p>Alt text provides image descriptions for people with vision impairments, low-bandwidth connections, or those seeking extra context.</p> <p>You can improve accessibility and understanding for everyone by writing clear, concise, and objective alt text.</p> <ul> <li>Capture important elements</li> <li>Summarize text in images</li> <li>Use regular sentence structure</li> <li>Avoid redundant information</li> <li>Focus on trends and key findings in complex visuals (like diagrams or maps)</li> </ul>",
  "interaction_modal.action": "To interact with {name}'s post, you need to sign into your account on whatever Mastodon server you use.",
  "interaction_modal.action_follow": "To follow {name}, you need to sign into your account on whatever Mastodon server you use.",
  "interaction_modal.go": "Go",
  "interaction_modal.no_account_yet": "Don't have an account yet?",
  "interaction_modal.on_another_server": "On a different server",
  "interaction_modal.on_this_server": "On this server",
  "interaction_modal.title": "Sign in to continue",
  "interaction_modal.username_prompt": "E.g. {example}",
  "intervals.full.days": "{number, plural, one {# day} other {# days}}",
  "intervals.full.hours": "{number, plural, one {# hour} other {# hours}}",
  "intervals.full.minutes": "{number, plural, one {# minute} other {# minutes}}",
  "keyboard_shortcuts.back": "Navigate back",
  "keyboard_shortcuts.blocked": "Open blocked users list",
  "keyboard_shortcuts.boost": "Boost post",
  "keyboard_shortcuts.column": "Focus column",
  "keyboard_shortcuts.compose": "Focus compose textarea",
  "keyboard_shortcuts.description": "Description",
  "keyboard_shortcuts.direct": "Open private mentions column",
  "keyboard_shortcuts.down": "Move down in the list",
  "keyboard_shortcuts.enter": "Open post",
  "keyboard_shortcuts.explore": "Open trending timeline",
  "keyboard_shortcuts.favourite": "Favorite post",
  "keyboard_shortcuts.favourites": "Open favorites list",
  "keyboard_shortcuts.federated": "Open federated timeline",
  "keyboard_shortcuts.heading": "Keyboard shortcuts",
  "keyboard_shortcuts.home": "Open home timeline",
  "keyboard_shortcuts.hotkey": "Hotkey",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "Backspace",
  "keyboard_shortcuts.keys.enter": "Enter",
  "keyboard_shortcuts.keys.esc": "Esc",
  "keyboard_shortcuts.keys.page_down": "Page Down",
  "keyboard_shortcuts.keys.page_up": "Page Up",
  "keyboard_shortcuts.legend": "Display this legend",
  "keyboard_shortcuts.load_more": "Focus \"Load more\" button",
  "keyboard_shortcuts.local": "Open local timeline",
  "keyboard_shortcuts.mention": "Mention author",
  "keyboard_shortcuts.muted": "Open muted users list",
  "keyboard_shortcuts.my_profile": "Open your profile",
  "keyboard_shortcuts.notifications": "Open notifications column",
  "keyboard_shortcuts.open_media": "Open media",
  "keyboard_shortcuts.pinned": "Open pinned posts list",
  "keyboard_shortcuts.profile": "Open author's profile",
  "keyboard_shortcuts.quote": "Quote post",
  "keyboard_shortcuts.reply": "Reply to post",
  "keyboard_shortcuts.requests": "Open follow requests list",
  "keyboard_shortcuts.search": "Focus search bar",
  "keyboard_shortcuts.spoilers": "Show/hide CW field",
  "keyboard_shortcuts.start": "Open “get started” column",
  "keyboard_shortcuts.toggle_hidden": "Show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "Show/hide media",
  "keyboard_shortcuts.toot": "Start a new post",
  "keyboard_shortcuts.top": "Move to top of list",
  "keyboard_shortcuts.translate": "Translate a post",
  "keyboard_shortcuts.unfocus": "Unfocus compose textarea/search",
  "keyboard_shortcuts.up": "Move up in the list",
  "learn_more_link.got_it": "Got it",
  "learn_more_link.learn_more": "Learn more",
  "lightbox.close": "Close",
  "lightbox.next": "Next",
  "lightbox.previous": "Previous",
  "lightbox.zoom_in": "Zoom to actual size",
  "lightbox.zoom_out": "Zoom to fit",
  "limited_account_hint.action": "Show profile anyway",
  "limited_account_hint.title": "This profile or server has been hidden by the moderators of {domain}.",
  "link_preview.author": "By {name}",
  "link_preview.more_from_author": "More from {name}",
  "link_preview.shares": "{count, plural, one {{counter} post} other {{counter} posts}}",
  "lists.add_member": "Add",
  "lists.add_to_list": "Add to list",
  "lists.add_to_lists": "Add {name} to lists",
  "lists.create": "Create",
  "lists.create_a_list_to_organize": "Create a new list to organize your Home feed",
  "lists.create_list": "Create list",
  "lists.delete": "Delete list",
  "lists.done": "Done",
  "lists.edit": "Edit list",
  "lists.exclusive": "Hide members in Home",
  "lists.exclusive_hint": "If someone is on this list, hide them in your Home feed to avoid seeing their posts twice.",
  "lists.find_users_to_add": "Find users to add",
  "lists.list_members_count": "{count, plural, one {# member} other {# members}}",
  "lists.list_name": "List name",
  "lists.new_list_name": "New list name",
  "lists.no_lists_yet": "No lists yet.",
  "lists.no_members_yet": "No members yet.",
  "lists.no_results_found": "No results found.",
  "lists.remove_member": "Remove",
  "lists.replies_policy.followed": "Any followed user",
  "lists.replies_policy.list": "Members of the list",
  "lists.replies_policy.none": "No one",
  "lists.save": "Save",
  "lists.search": "Search",
  "lists.show_replies_to": "Include replies from list members to",
  "load_pending": "{count, plural, one {# new item} other {# new items}}",
  "loading_indicator.label": "Loading…",
  "media_gallery.hide": "Hide",
  "moved_to_account_banner.text": "Your account {disabledAccount} is currently disabled because you moved to {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Hide from notifications",
  "mute_modal.hide_options": "Hide options",
  "mute_modal.indefinite": "Until I unmute them",
  "mute_modal.show_options": "Show options",
  "mute_modal.they_can_mention_and_follow": "They can mention and follow you, but you won't see them.",
  "mute_modal.they_wont_know": "They won't know they've been muted.",
  "mute_modal.title": "Mute user?",
  "mute_modal.you_wont_see_mentions": "You won't see posts that mention them.",
  "mute_modal.you_wont_see_posts": "They can still see your posts, but you won't see theirs.",
  "navigation_bar.about": "About",
  "navigation_bar.account_settings": "Password and security",
  "navigation_bar.administration": "Administration",
  "navigation_bar.advanced_interface": "Open in advanced web interface",
  "navigation_bar.automated_deletion": "Automated post deletion",
  "navigation_bar.blocked_accounts": "Blocked Accounts",
  "navigation_bar.blocks": "Blocked users",
  "navigation_bar.bookmarks": "Bookmarks",
  "navigation_bar.collections": "Collections",
  "navigation_bar.direct": "Private mentions",
  "navigation_bar.domain_blocks": "Blocked domains",
  "navigation_bar.favourites": "Favorites",
  "navigation_bar.filters": "Muted words",
  "navigation_bar.follow_requests": "Follow requests",
  "navigation_bar.followed_tags": "Followed hashtags",
  "navigation_bar.followers_and_following": "Followers & Following",
  "navigation_bar.follows_and_followers": "Follows and followers",
  "navigation_bar.import_export": "Import and export",
  "navigation_bar.liked_posts": "Liked Posts",
  "navigation_bar.lists": "Lists",
  "navigation_bar.live_feed_local": "Live feed (local)",
  "navigation_bar.live_feed_public": "Live feed (public)",
  "navigation_bar.logout": "Logout",
  "navigation_bar.main": "Main",
  "navigation_bar.moderation": "Moderation",
  "navigation_bar.more": "More",
  "navigation_bar.mutes": "Muted users",
  "navigation_bar.opened_in_classic_interface": "Posts, accounts, and other specific pages are opened by default in the classic web interface.",
  "navigation_bar.powered_by_mastodon": "powered by {logo}Mastodon",
  "navigation_bar.preferences": "Preferences",
  "navigation_bar.privacy_and_reach": "Privacy and reach",
  "navigation_bar.search": "Search",
  "navigation_bar.search_trends": "Search / Trending",
  "navigation_bar.sign_out": "Sign out",
  "navigation_panel.collapse_followed_tags": "Collapse followed hashtags menu",
  "navigation_panel.collapse_lists": "Collapse list menu",
  "navigation_panel.expand_followed_tags": "Expand followed hashtags menu",
  "navigation_panel.expand_lists": "Expand list menu",
  "not_signed_in_indicator.not_signed_in": "You need to login to access this resource.",
  "notification.added_to_collection": "{name} added you to a collection",
  "notification.admin.report": "{name} reported {target}",
  "notification.admin.report_account": "{name} reported {count, plural, one {one post} other {# posts}} from {target} for {category}",
  "notification.admin.report_account_other": "{name} reported {count, plural, one {one post} other {# posts}} from {target}",
  "notification.admin.report_statuses": "{name} reported {target} for {category}",
  "notification.admin.report_statuses_other": "{name} reported {target}",
  "notification.admin.sign_up": "{name} signed up",
  "notification.admin.sign_up.name_and_others": "{name} and {count, plural, one {# other} other {# others}} signed up",
  "notification.annual_report.message": "Your {year} #Wrapstodon awaits! Unveil your year's highlights and memorable moments on Mastodon!",
  "notification.annual_report.view": "View #Wrapstodon",
  "notification.collection_update": "{name} edited a collection you’re in",
  "notification.favourite": "{name} favorited your post",
  "notification.favourite.name_and_others_with_link": "{name} and <a>{count, plural, one {# other} other {# others}}</a> favorited your post",
  "notification.favourite_pm": "{name} favorited your private mention",
  "notification.favourite_pm.name_and_others_with_link": "{name} and <a>{count, plural, one {# other} other {# others}}</a> favorited your private mention",
  "notification.follow": "{name} followed you",
  "notification.follow.name_and_others": "{name} and <a>{count, plural, one {# other} other {# others}}</a> followed you",
  "notification.follow_request": "{name} has requested to follow you",
  "notification.follow_request.name_and_others": "{name} and {count, plural, one {# other} other {# others}} has requested to follow you",
  "notification.label.mention": "Mention",
  "notification.label.private_mention": "Private mention",
  "notification.label.private_reply": "Private reply",
  "notification.label.quote": "{name} quoted your post",
  "notification.label.reply": "Reply",
  "notification.mention": "Mention",
  "notification.mentioned_you": "{name} mentioned you",
  "notification.moderation-warning.learn_more": "Learn more",
  "notification.moderation_warning": "You have received a moderation warning",
  "notification.moderation_warning.action_delete_statuses": "Some of your posts have been removed.",
  "notification.moderation_warning.action_disable": "Your account has been disabled.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Some of your posts have been marked as sensitive.",
  "notification.moderation_warning.action_none": "Your account has received a moderation warning.",
  "notification.moderation_warning.action_sensitive": "Your posts will be marked as sensitive from now on.",
  "notification.moderation_warning.action_silence": "Your account has been limited.",
  "notification.moderation_warning.action_suspend": "Your account has been suspended.",
  "notification.own_poll": "Your poll has ended",
  "notification.poll": "A poll you voted in has ended",
  "notification.quoted_update": "{name} edited a post you have quoted",
  "notification.reblog": "{name} boosted your post",
  "notification.reblog.name_and_others_with_link": "{name} and <a>{count, plural, one {# other} other {# others}}</a> boosted your post",
  "notification.relationships_severance_event": "Lost connections with {name}",
  "notification.relationships_severance_event.account_suspension": "An admin from {from} has suspended {target}, which means you can no longer receive updates from them or interact with them.",
  "notification.relationships_severance_event.domain_block": "An admin from {from} has blocked {target}, including {followersCount} of your followers and {followingCount, plural, one {# account} other {# accounts}} you follow.",
  "notification.relationships_severance_event.learn_more": "Learn more",
  "notification.relationships_severance_event.user_domain_block": "You have blocked {target}, removing {followersCount} of your followers and {followingCount, plural, one {# account} other {# accounts}} you follow.",
  "notification.status": "{name} just posted",
  "notification.update": "{name} edited a post",
  "notification_requests.accept": "Accept",
  "notification_requests.accept_multiple": "{count, plural, one {Accept # request…} other {Accept # requests…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Accept request} other {Accept requests}}",
  "notification_requests.confirm_accept_multiple.message": "You are about to accept {count, plural, one {one notification request} other {# notification requests}}. Are you sure you want to proceed?",
  "notification_requests.confirm_accept_multiple.title": "Accept notification requests?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Dismiss request} other {Dismiss requests}}",
  "notification_requests.confirm_dismiss_multiple.message": "You are about to dismiss {count, plural, one {one notification request} other {# notification requests}}. You won't be able to easily access {count, plural, one {it} other {them}} again. Are you sure you want to proceed?",
  "notification_requests.confirm_dismiss_multiple.title": "Dismiss notification requests?",
  "notification_requests.dismiss": "Dismiss",
  "notification_requests.dismiss_multiple": "{count, plural, one {Dismiss # request…} other {Dismiss # requests…}}",
  "notification_requests.edit_selection": "Edit",
  "notification_requests.exit_selection": "Done",
  "notification_requests.explainer_for_limited_account": "Notifications from this account have been filtered because the account has been limited by a moderator.",
  "notification_requests.explainer_for_limited_remote_account": "Notifications from this account have been filtered because the account or its server has been limited by a moderator.",
  "notification_requests.maximize": "Maximize",
  "notification_requests.minimize_banner": "Minimize filtered notifications banner",
  "notification_requests.notifications_from": "Notifications from {name}",
  "notification_requests.title": "Filtered notifications",
  "notification_requests.view": "View notifications",
  "notifications.clear": "Clear notifications",
  "notifications.clear_confirmation": "Are you sure you want to permanently clear all your notifications?",
  "notifications.clear_title": "Clear notifications?",
  "notifications.column_settings.admin.report": "New reports:",
  "notifications.column_settings.admin.sign_up": "New sign-ups:",
  "notifications.column_settings.alert": "Desktop notifications",
  "notifications.column_settings.collections": "Collections:",
  "notifications.column_settings.favourite": "Favorites:",
  "notifications.column_settings.filter_bar.advanced": "Display all categories",
  "notifications.column_settings.filter_bar.category": "Quick filter bar",
  "notifications.column_settings.follow": "New followers:",
  "notifications.column_settings.follow_request": "New follow requests:",
  "notifications.column_settings.group": "Group",
  "notifications.column_settings.mention": "Mentions:",
  "notifications.column_settings.poll": "Poll results:",
  "notifications.column_settings.push": "Push notifications",
  "notifications.column_settings.quote": "Quotes:",
  "notifications.column_settings.reblog": "Boosts:",
  "notifications.column_settings.show": "Show in column",
  "notifications.column_settings.sound": "Play sound",
  "notifications.column_settings.status": "New posts:",
  "notifications.column_settings.unread_notifications.category": "Unread notifications",
  "notifications.column_settings.unread_notifications.highlight": "Highlight unread notifications",
  "notifications.column_settings.update": "Edits:",
  "notifications.filter.all": "All",
  "notifications.filter.boosts": "Boosts",
  "notifications.filter.collections": "Collections",
  "notifications.filter.favourites": "Favorites",
  "notifications.filter.follows": "Follows",
  "notifications.filter.mentions": "Mentions",
  "notifications.filter.polls": "Poll results",
  "notifications.filter.statuses": "Updates from people you follow",
  "notifications.grant_permission": "Grant permission.",
  "notifications.group": "{count} notifications",
  "notifications.mark_as_read": "Mark every notification as read",
  "notifications.permission_denied": "Desktop notifications are unavailable due to previously denied browser permissions request",
  "notifications.permission_denied_alert": "Desktop notifications can't be enabled, as browser permission has been denied before",
  "notifications.permission_required": "Desktop notifications are unavailable because the required permission has not been granted.",
  "notifications.policy.accept": "Accept",
  "notifications.policy.accept_hint": "Show in notifications",
  "notifications.policy.drop": "Ignore",
  "notifications.policy.drop_hint": "Send to the void, never to be seen again",
  "notifications.policy.filter": "Filter",
  "notifications.policy.filter_bots_hint": "Accounts marked as automated",
  "notifications.policy.filter_bots_title": "Bots",
  "notifications.policy.filter_hint": "Send to filtered notifications inbox",
  "notifications.policy.filter_limited_accounts_hint": "Limited by server moderators",
  "notifications.policy.filter_limited_accounts_title": "Moderated accounts",
  "notifications.policy.filter_new_accounts.hint": "Created within the past {days, plural, one {one day} other {# days}}",
  "notifications.policy.filter_new_accounts_title": "New accounts",
  "notifications.policy.filter_not_followers_hint": "Including people who have been following you fewer than {days, plural, one {one day} other {# days}}",
  "notifications.policy.filter_not_followers_title": "People not following you",
  "notifications.policy.filter_not_following_hint": "Until you manually approve them",
  "notifications.policy.filter_not_following_title": "People you don't follow",
  "notifications.policy.filter_private_mentions_hint": "Filtered unless it's in reply to your own mention or if you follow the sender",
  "notifications.policy.filter_private_mentions_title": "Unsolicited private mentions",
  "notifications.policy.title": "Manage notifications from…",
  "notifications.settings": "Notification Settings",
  "notifications_permission_banner.enable": "Enable desktop notifications",
  "notifications_permission_banner.how_to_control": "To receive notifications when Mastodon isn't open, enable desktop notifications. You can control precisely which types of interactions generate desktop notifications through the {icon} button above once they're enabled.",
  "notifications_permission_banner.title": "Never miss a thing",
  "onboarding.follows.back": "Back",
  "onboarding.follows.empty": "Unfortunately, no results can be shown right now. You can try using search or browsing the explore page to find people to follow, or try again later.",
  "onboarding.follows.next": "Next: Setup your profile",
  "onboarding.follows.search": "Search",
  "onboarding.follows.title": "Follow people to get started",
  "onboarding.profile.discoverable": "Make my profile discoverable",
  "onboarding.profile.discoverable_hint": "When you opt in to discoverability on Mastodon, your posts may appear in search results and trending, and your profile may be suggested to people with similar interests to you.",
  "onboarding.profile.display_name": "Display name",
  "onboarding.profile.display_name_hint": "Your full name or your fun name…",
  "onboarding.profile.finish": "Finish",
  "onboarding.profile.note": "Bio",
  "onboarding.profile.note_hint": "You can @mention other people or #hashtags…",
  "onboarding.profile.title": "Profile setup",
  "onboarding.profile.upload_avatar": "Upload profile picture",
  "onboarding.profile.upload_header": "Upload profile header",
  "password_confirmation.exceeds_maxlength": "Password confirmation exceeds the maximum password length",
  "password_confirmation.mismatching": "Password confirmation does not match",
  "picture_in_picture.restore": "Put it back",
  "poll.closed": "Closed",
  "poll.refresh": "Refresh",
  "poll.reveal": "See results",
  "poll.total_people": "{count, plural, one {# person} other {# people}}",
  "poll.total_votes": "{count, plural, one {# vote} other {# votes}}",
  "poll.vote": "Vote",
  "poll.voted": "You voted for this answer",
  "poll.votes": "{votes, plural, one {# vote} other {# votes}}",
  "poll_button.add_poll": "Add a poll",
  "poll_button.remove_poll": "Remove poll",
  "privacy.change": "Change post privacy",
  "privacy.direct.long": "Everyone mentioned in the post",
  "privacy.direct.short": "Private mention",
  "privacy.private.long": "Only your followers",
  "privacy.private.short": "Followers",
  "privacy.public.long": "Anyone on and off Mastodon",
  "privacy.public.short": "Public",
  "privacy.quote.anyone": "{visibility}, quotes allowed",
  "privacy.quote.disabled": "{visibility}, quotes disabled",
  "privacy.quote.limited": "{visibility}, quotes limited",
  "privacy.unlisted.additional": "This behaves exactly like public, except the post will not appear in live feeds or hashtags, explore, or Mastodon search, even if you are opted-in account-wide.",
  "privacy.unlisted.long": "Hidden from Mastodon search results, trending, and public timelines",
  "privacy.unlisted.short": "Quiet public",
  "privacy_policy.last_updated": "Last updated {date}",
  "privacy_policy.title": "Privacy Policy",
  "quote_error.edit": "Quotes cannot be added when editing a post.",
  "quote_error.poll": "Quoting is not allowed with polls.",
  "quote_error.private_mentions": "Quoting is not allowed with direct mentions.",
  "quote_error.quote": "Only one quote at a time is allowed.",
  "quote_error.unauthorized": "You are not authorized to quote this post.",
  "quote_error.upload": "Quoting is not allowed with media attachments.",
  "recommended": "Recommended",
  "refresh": "Refresh",
  "regeneration_indicator.please_stand_by": "Please stand by.",
  "regeneration_indicator.preparing_your_home_feed": "Preparing your home feed…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural, one {# day} other {# days}} ago",
  "relative_time.full.hours": "{number, plural, one {# hour} other {# hours}} ago",
  "relative_time.full.just_now": "just now",
  "relative_time.full.minutes": "{number, plural, one {# minute} other {# minutes}} ago",
  "relative_time.full.seconds": "{number, plural, one {# second} other {# seconds}} ago",
  "relative_time.hours": "{number}h",
  "relative_time.just_now": "now",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "today",
  "remove_quote_hint.button_label": "Got it",
  "remove_quote_hint.message": "You can do so from the {icon} options menu.",
  "remove_quote_hint.title": "Want to remove your quoted post?",
  "reply_indicator.attachments": "{count, plural, one {# attachment} other {# attachments}}",
  "reply_indicator.cancel": "Cancel",
  "reply_indicator.poll": "Poll",
  "report.block": "Block",
  "report.block_explanation": "You will not see their posts. They will not be able to see your posts or follow you. They will be able to tell that they are blocked.",
  "report.categories.legal": "Legal",
  "report.categories.other": "Other",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Content violates one or more server rules",
  "report.category.subtitle": "Choose the best match",
  "report.category.title_account": "Tell us what's going on with this profile",
  "report.category.title_collection": "Tell us what's going on with this collection",
  "report.category.title_status": "Tell us what's going on with this post",
  "report.close": "Done",
  "report.comment.title": "Is there anything else you think we should know?",
  "report.forward": "Forward to {target}",
  "report.forward_hint": "The account is from another server. Send an anonymized copy of the report there as well?",
  "report.mute": "Mute",
  "report.mute_explanation": "You will not see their posts. They can still follow you and see your posts and will not know that they are muted.",
  "report.next": "Next",
  "report.placeholder": "Additional comments",
  "report.reasons.dislike": "I don't like it",
  "report.reasons.dislike_description": "It is not something you want to see",
  "report.reasons.legal": "It's illegal",
  "report.reasons.legal_description": "You believe it violates the law of your or the server's country",
  "report.reasons.other": "It's something else",
  "report.reasons.other_description": "The issue does not fit into other categories",
  "report.reasons.spam": "It's spam",
  "report.reasons.spam_description": "Malicious links, fake engagement, or repetitive replies",
  "report.reasons.violation": "It violates server rules",
  "report.reasons.violation_description": "You are aware that it breaks specific rules",
  "report.rules.subtitle": "Select all that apply",
  "report.rules.title": "Which rules are being violated?",
  "report.statuses.subtitle": "Select all that apply",
  "report.statuses.title": "Are there any posts that back up this report?",
  "report.submission_error": "Report could not be submitted",
  "report.submission_error_details": "Please check your network connection and try again later.",
  "report.submit": "Submit",
  "report.target": "Reporting {target}",
  "report.thanks.take_action": "Here are your options for controlling what you see on Mastodon:",
  "report.thanks.take_action_actionable": "While we review this, you can take action against @{name}:",
  "report.thanks.title": "Don't want to see this?",
  "report.thanks.title_actionable": "Thanks for reporting, we'll look into this.",
  "report.unfollow": "Unfollow @{name}",
  "report.unfollow_explanation": "You are following this account. To not see their posts in your home feed anymore, unfollow them.",
  "report_notification.attached_statuses": "{count, plural, one {{count} post} other {{count} posts}} attached",
  "report_notification.categories.legal": "Legal",
  "report_notification.categories.legal_sentence": "illegal content",
  "report_notification.categories.other": "Other",
  "report_notification.categories.other_sentence": "other",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Rule violation",
  "report_notification.categories.violation_sentence": "rule violation",
  "report_notification.open": "Open report",
  "search.clear": "Clear search",
  "search.no_recent_searches": "No recent searches",
  "search.placeholder": "Search",
  "search.quick_action.account_search": "Profiles matching {x}",
  "search.quick_action.go_to_account": "Go to profile {x}",
  "search.quick_action.go_to_hashtag": "Go to hashtag {x}",
  "search.quick_action.open_url": "Open URL in Mastodon",
  "search.quick_action.status_search": "Posts matching {x}",
  "search.search_or_paste": "Search or paste URL",
  "search_popout.full_text_search_disabled_message": "Not available on {domain}.",
  "search_popout.full_text_search_logged_out_message": "Only available when logged in.",
  "search_popout.language_code": "ISO language code",
  "search_popout.options": "Search options",
  "search_popout.quick_actions": "Quick actions",
  "search_popout.recent": "Recent searches",
  "search_popout.specific_date": "specific date",
  "search_popout.user": "user",
  "search_results.accounts": "Profiles",
  "search_results.all": "All",
  "search_results.collections": "Collections",
  "search_results.hashtags": "Hashtags",
  "search_results.no_results": "No results.",
  "search_results.no_search_yet": "Try searching for posts, profiles or hashtags.",
  "search_results.see_all": "See all",
  "search_results.statuses": "Posts",
  "search_results.title": "Search for \"{q}\"",
  "server_banner.about_active_users": "People using this server during the last 30 days (Monthly Active Users)",
  "server_banner.active_users": "active users",
  "server_banner.administered_by": "Administered by:",
  "server_banner.create_account": "Create an account",
  "server_banner.is_one_of_many": "{domain} is one of the many independent Mastodon servers you can use to participate in the fediverse.",
  "server_banner.log_in": "Log in",
  "server_banner.more_about_this_server": "More about this server",
  "server_banner.server_stats": "Server stats:",
  "sign_in_banner.create_account": "Create account",
  "sign_in_banner.follow_anyone": "Follow anyone across the fediverse and see it all in chronological order. No algorithms, ads, or clickbait in sight.",
  "sign_in_banner.mastodon_is": "Mastodon is the best way to keep up with what's happening.",
  "sign_in_banner.sign_in": "Login",
  "sign_in_banner.sso_redirect": "Login or Register",
  "skip_links.hotkey": "<span>Hotkey</span> {hotkey}",
  "skip_links.skip_to_content": "Skip to main content",
  "skip_links.skip_to_navigation": "Skip to main navigation",
  "status.admin_account": "Open moderation interface for @{name}",
  "status.admin_domain": "Open moderation interface for {domain}",
  "status.admin_status": "Open this post in the moderation interface",
  "status.all_disabled": "Boosts and quotes are disabled",
  "status.block": "Block @{name}",
  "status.bookmark": "Bookmark",
  "status.cancel_reblog_private": "Unboost",
  "status.cannot_edit": "You are not allowed to edit this post",
  "status.cannot_quote": "You are not allowed to quote this post",
  "status.cannot_reblog": "This post cannot be boosted",
  "status.contains_quote": "Contains quote",
  "status.context.loading": "Loading more replies",
  "status.context.loading_error": "Couldn't load new replies",
  "status.context.loading_success": "New replies loaded",
  "status.context.more_replies_found": "More replies found",
  "status.context.retry": "Retry",
  "status.context.show": "Show",
  "status.continued_thread": "Continued thread",
  "status.copy": "Copy link to post",
  "status.delete": "Delete",
  "status.delete.success": "Post deleted",
  "status.detailed_status": "Detailed conversation view",
  "status.direct": "Privately mention @{name}",
  "status.direct_indicator": "Private mention",
  "status.edit": "Edit",
  "status.edited": "Last edited {date}",
  "status.edited_x_times": "Edited {count, plural, one {{count} time} other {{count} times}}",
  "status.embed": "Get embed code",
  "status.favourite": "Favorite",
  "status.favourites_count": "{count, plural, one {{counter} favorite} other {{counter} favorites}}",
  "status.filter": "Filter this post",
  "status.history.created": "{name} created {date}",
  "status.history.edited": "{name} edited {date}",
  "status.likes_title": "Post Likes",
  "status.load_more": "Load more",
  "status.media.open": "Click to open",
  "status.media.show": "Click to show",
  "status.media_hidden": "Media hidden",
  "status.mention": "Mention @{name}",
  "status.more": "More",
  "status.mute": "Mute @{name}",
  "status.mute_conversation": "Mute conversation",
  "status.not_quoted": "You are not quoted in this post",
  "status.open": "Expand this post",
  "status.options": "Post options",
  "status.pin": "Pin on profile",
  "status.public_only": "This post is private",
  "status.quote": "Quote",
  "status.quote.cancel": "Cancel quote",
  "status.quote_error.blocked_account_hint.title": "This post is hidden because you've blocked @{name}.",
  "status.quote_error.blocked_domain_hint.title": "This post is hidden because you've blocked {domain}.",
  "status.quote_error.filtered": "Hidden due to one of your filters",
  "status.quote_error.limited_account_hint.action": "Show anyway",
  "status.quote_error.limited_account_hint.title": "This account has been hidden by the moderators of {domain}.",
  "status.quote_error.muted_account_hint.title": "This post is hidden because you've muted @{name}.",
  "status.quote_error.not_available": "Post unavailable",
  "status.quote_error.pending_approval": "Post pending",
  "status.quote_error.pending_approval_popout.body": "On Mastodon, you can control whether someone can quote you. This post is pending while we're getting the original author's approval.",
  "status.quote_error.revoked": "Post removed by author",
  "status.quote_followers_only": "Only followers can quote this post",
  "status.quote_manual_review": "Author will manually review",
  "status.quote_noun": "Quote",
  "status.quote_policy_change": "Change who can quote",
  "status.quote_post_author": "Quoted a post by @{name}",
  "status.quote_private": "Private posts cannot be quoted",
  "status.quotes.empty": "No one has quoted this post yet. When someone does, it will show up here.",
  "status.quotes.local_other_disclaimer": "Quotes rejected by the author will not be shown.",
  "status.quotes.remote_other_disclaimer": "Only quotes from {domain} are guaranteed to be shown here. Quotes rejected by the author will not be shown.",
  "status.quotes_count": "{count, plural, one {{counter} quote} other {{counter} quotes}}",
  "status.read_more": "Read more",
  "status.reblog": "Boost",
  "status.reblog_or_quote": "Boost or quote",
  "status.reblog_private": "Share again with your followers",
  "status.reblogged_by": "{name} boosted",
  "status.reblogs.empty": "No one has boosted this post yet. When someone does, they will show up here.",
  "status.reblogs_count": "{count, plural, one {{counter} boost} other {{counter} boosts}}",
  "status.redraft": "Delete & re-draft",
  "status.remove_bookmark": "Remove bookmark",
  "status.remove_favourite": "Remove from favorites",
  "status.remove_quote": "Remove",
  "status.replied_in_thread": "Replied in thread",
  "status.replied_to": "Replied to {name}",
  "status.reply": "Reply",
  "status.replyAll": "Reply to thread",
  "status.report": "Report @{name}",
  "status.request_quote": "Request to quote",
  "status.revoke_quote": "Remove my post from @{name}’s post",
  "status.sensitive_warning": "Sensitive content",
  "status.share": "Share",
  "status.show_less_all": "Show less for all",
  "status.show_more_all": "Show more for all",
  "status.show_original": "Show original",
  "status.title": "Post by {name}",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {{attachmentCount} attachments}}",
  "status.translate": "Translate",
  "status.translated_from_with": "Translated from {lang} using {provider}",
  "status.uncached_media_warning": "Preview not available",
  "status.unmute_conversation": "Unmute conversation",
  "status.unpin": "Unpin from profile",
  "subscribed_languages.lead": "Only posts in selected languages will appear on your home and list timelines after the change. Select none to receive posts in all languages.",
  "subscribed_languages.save": "Save changes",
  "subscribed_languages.target": "Change subscribed languages for {target}",
  "tab_bar.messages": "Messages",
  "tabs_bar.create_custom_feed": "Create feed",
  "tabs_bar.custom_feeds": "Custom Feeds",
  "tabs_bar.custom_feeds_empty": "You have no custom feeds yet.",
  "tabs_bar.explore": "Explore",
  "tabs_bar.fediverse_feeds": "Fediverse Feeds",
  "tabs_bar.followed_hashtags": "Followed Hashtags",
  "tabs_bar.followed_tags_view_all": "View all",
  "tabs_bar.home": "Home",
  "tabs_bar.menu": "Menu",
  "tabs_bar.messages": "Messages",
  "tabs_bar.more": "More",
  "tabs_bar.notifications": "Notifications",
  "tabs_bar.profile": "Profile",
  "tabs_bar.publish": "New Post",
  "tabs_bar.quick_links": "Quick links",
  "tabs_bar.saved": "Saved",
  "tabs_bar.search": "Search",
  "tabs_bar.settings": "Settings",
  "tag.remove": "Remove",
  "terms_of_service.effective_as_of": "Effective as of {date}",
  "terms_of_service.title": "Terms of Service",
  "terms_of_service.upcoming_changes_on": "Upcoming changes on {date}",
  "time_remaining.days": "{number, plural, one {# day} other {# days}} left",
  "time_remaining.hours": "{number, plural, one {# hour} other {# hours}} left",
  "time_remaining.minutes": "{number, plural, one {# minute} other {# minutes}} left",
  "time_remaining.moments": "Moments remaining",
  "time_remaining.seconds": "{number, plural, one {# second} other {# seconds}} left",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {{days} days}}",
  "trends.trending_now": "Trending now",
  "ui.beforeunload": "Your draft will be lost if you leave Mastodon.",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Drag & drop to upload",
  "upload_button.label": "Add images, a video or an audio file",
  "upload_error.limit": "File upload limit exceeded.",
  "upload_error.poll": "File upload not allowed with polls.",
  "upload_error.quote": "File upload not allowed with quotes.",
  "upload_form.drag_and_drop.instructions": "To pick up a media attachment, press space or enter. While dragging, use the arrow keys to move the media attachment in any given direction. Press space or enter again to drop the media attachment in its new position, or press escape to cancel.",
  "upload_form.drag_and_drop.on_drag_cancel": "Dragging was cancelled. Media attachment {item} was dropped.",
  "upload_form.drag_and_drop.on_drag_end": "Media attachment {item} was dropped.",
  "upload_form.drag_and_drop.on_drag_over": "Media attachment {item} was moved.",
  "upload_form.drag_and_drop.on_drag_start": "Picked up media attachment {item}.",
  "upload_form.edit": "Edit",
  "upload_progress.label": "Uploading...",
  "upload_progress.processing": "Processing…",
  "username.taken": "That username is taken. Try another",
  "video.close": "Close video",
  "video.download": "Download file",
  "video.exit_fullscreen": "Exit full screen",
  "video.expand": "Expand video",
  "video.fullscreen": "Full screen",
  "video.hide": "Hide video",
  "video.mute": "Mute",
  "video.pause": "Pause",
  "video.play": "Play",
  "video.skip_backward": "Skip backward",
  "video.skip_forward": "Skip forward",
  "video.unmute": "Unmute",
  "video.volume_down": "Volume down",
  "video.volume_up": "Volume up",
  "visibility_modal.button_title": "Set visibility",
  "visibility_modal.direct_quote_warning.text": "If you save the current settings, the embedded quote will be converted to a link.",
  "visibility_modal.direct_quote_warning.title": "Quotes can't be embedded in private mentions",
  "visibility_modal.header": "Visibility and interaction",
  "visibility_modal.helper.direct_quoting": "Private mentions authored on Mastodon can't be quoted by others.",
  "visibility_modal.helper.privacy_editing": "Visibility can't be changed after a post is published.",
  "visibility_modal.helper.privacy_private_self_quote": "Self-quotes of private posts cannot be made public.",
  "visibility_modal.helper.private_quoting": "Follower-only posts authored on Mastodon can't be quoted by others.",
  "visibility_modal.helper.unlisted_quoting": "When people quote you, their post will also be hidden from trending timelines.",
  "visibility_modal.instructions": "Control who can interact with this post. You can also apply settings to all future posts by navigating to <link>Preferences > Posting defaults</link>.",
  "visibility_modal.privacy_label": "Visibility",
  "visibility_modal.quote_followers": "Followers only",
  "visibility_modal.quote_label": "Who can quote",
  "visibility_modal.quote_nobody": "Just me",
  "visibility_modal.quote_public": "Anyone",
  "visibility_modal.save": "Save"
}
